import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bdd3e900&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=bdd3e900&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=bdd3e900&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd3e900",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdd3e900')) {
      api.createRecord('bdd3e900', component.options)
    } else {
      api.reload('bdd3e900', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=bdd3e900&scoped=true", function () {
      api.rerender('bdd3e900', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P1_Boys/PayStore/index.vue"
export default component.exports